/**
 * 评价模块API
 */

export default {
  // 查看他人的评价
  rateIndexList: `${process.env.VUE_APP_API_URL}${process.env.VUE_APP_PREFIX_STR}/rate/index/list`,
};
